import React from "react"
import { FaSearch } from "react-icons/fa"
import { type Props } from "./_types"
const IconSearch: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <FaSearch size={size} color={color} />
}

export default IconSearch
